var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import fetch from 'isomorphic-fetch';
import { datadogLogs } from '@datadog/browser-logs';
import { noop } from '../../utils/noop';
import { getDshHeader } from '../../statsig';
var state = {
    mockResponseOverrides: [],
    cToken: null,
};
var C_TOKEN_HEADER = 'X-Ct';
var DSH_HEADER = 'Dersh-Id';
export var setIsoFetchOverrides = function (mockResponseOverrides) {
    state.mockResponseOverrides = mockResponseOverrides;
};
export var clearIsoFetchOverrides = function () {
    state.mockResponseOverrides = [];
};
var CORS_FAILURE_MESSAGES = new Set([
    // Chrome
    'Failed to fetch',
    // Safari
    'Load failed',
]);
/**
 * This function simply wraps isomorphic fetch for easy mocking in tests.
 * This module is the preferred access method of isomorphic fetch throughout the
 * application.
 *
 * @returns Returns the isomorphic fetch module
 */
var getFetch = function () {
    if (process.env.STORYBOOK) {
        return function mockFetch() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var override = state.mockResponseOverrides.find(function (x) {
                return x.check.apply(x, args);
            });
            return {
                json: function () {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    return override ? override.response : new Promise(function (resolve) { });
                },
                headers: { get: noop },
            };
        };
    }
    return function (input, init) { return __awaiter(void 0, void 0, void 0, function () {
        var securityHeaders, headers, result_1, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    securityHeaders = (_a = {},
                        _a[C_TOKEN_HEADER] = state.cToken,
                        _a[DSH_HEADER] = getDshHeader(),
                        _a);
                    headers = (init === null || init === void 0 ? void 0 : init.headers)
                        ? __assign(__assign({}, init.headers), securityHeaders) : securityHeaders;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(input, __assign(__assign({}, init), { headers: headers }))];
                case 2:
                    result_1 = _b.sent();
                    return [2 /*return*/, result_1];
                case 3:
                    e_1 = _b.sent();
                    // CORS errors are undetectable at code level: https://stackoverflow.com/questions/19325314/how-to-detect-cross-origin-cors-error-vs-other-types-of-errors-for-xmlhttpreq
                    // They only give a generic fail message
                    if (CORS_FAILURE_MESSAGES.has(e_1.message)) {
                        datadogLogs.logger.error('client_fetch_failure');
                    }
                    throw e_1;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export default getFetch;
